import { Loader2, Info } from "lucide-react";
import { photoUrl } from "@/lib/api";

export const Loader = ({ text = "Caricamento…", testid = "loader" }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-20 text-[#0D2517]" data-testid={testid}>
    <Loader2 className="animate-spin" size={28} />
    <p className="text-sm text-[#5b6b60]">{text}</p>
  </div>
);

const LEVEL_STYLE = {
  alta: "bg-[#15803D]/10 text-[#15803D] border-[#15803D]/30",
  media: "bg-[#D97706]/10 text-[#B45309] border-[#D97706]/30",
  bassa: "bg-[#B91C1C]/10 text-[#B91C1C] border-[#B91C1C]/30",
  probabile: "bg-[#15803D]/10 text-[#15803D] border-[#15803D]/30",
  da_confermare: "bg-[#D97706]/10 text-[#B45309] border-[#D97706]/30",
  non_determinabile: "bg-stone-100 text-stone-600 border-stone-200",
};
const LEVEL_TEXT = { probabile: "Probabile", da_confermare: "Da confermare", non_determinabile: "Non determinabile" };

export const LevelBadge = ({ level, label = "Attendibilità", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${LEVEL_STYLE[level] || "bg-stone-100 text-stone-600 border-stone-200"}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {label}: {LEVEL_TEXT[level] || (level ? level.charAt(0).toUpperCase() + level.slice(1) : "n.d.")}
  </span>
);

export const Disclaimer = ({ compact, className = "border-[#c9a96e] bg-[#f8f3e9]" }) => (
  <div className={`flex gap-3 rounded-xl border ${className} ${compact ? "p-3" : "p-4"}`} data-testid="ai-disclaimer">
    <Info size={18} className="mt-0.5 shrink-0 text-[#B39257]" />
    <p className="text-xs leading-relaxed text-[#2D3A30]">
      L'analisi AI è <strong>preliminare</strong>: non sostituisce una diagnosi professionale, un'osservazione diretta o un
      esame di laboratorio quando questi sono necessari.
    </p>
  </div>
);

export const PhotoThumb = ({ id, className = "", testid }) => (
  <img src={photoUrl(id)} alt="Fotografia della pianta" loading="lazy" data-testid={testid}
    className={`rounded-lg object-cover bg-[#ddc69c]/40 ${className}`} />
);

export const SectionTitle = ({ eyebrow, children, testid }) => (
  <div className="mb-3" data-testid={testid}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2 className="font-serif text-2xl font-semibold text-[#0D2517]">{children}</h2>
  </div>
);

export const Card = ({ children, className = "", testid, accent }) => (
  <section data-testid={testid} className={`rounded-2xl border border-[#ddc69c]/70 bg-white p-5 shadow-sm ${accent ? "border-t-2 border-t-[#c9a96e]" : ""} ${className}`}>
    {children}
  </section>
);
